import(/* webpackMode: "eager" */ "/opt/buildhome/repo/inversum/node_modules/@fontsource-variable/manrope/index.css");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/inversum/node_modules/@fontsource-variable/dm-sans/index.css");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/inversum/node_modules/@fontsource-variable/dm-sans/wght-italic.css");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/inversum/node_modules/@fontsource-variable/jetbrains-mono/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/inversum/src/app/home/components/ShootingStarCursor.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/inversum/src/styles/tailwind.css");
